import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import HoverTooltip from '../HoverTooltip';
import InputWrapper from '../InputWrapper';
import ValidationMessage from '../ValidationMessage';
import Input from '../Input';

const InlineTextInput = ({
  id,
  inputs,
  isDisabled,
  isRequired,
  label,
  name,
  tooltipContent,
  tooltipPosition,
  type,
  validationMessage,
  validationState,

  hoverTooltipProps,
  inputLabelProps,
  inputWrapperProps,
  validationProps,
  wrapperProps
}) => (
  <InputWrapper
    validationState={validationState}
    type={type}
    {...wrapperProps}
    inputLabelProps={inputLabelProps}
    isRequired={isRequired}
    label={label}
    id={id}
    name={name}
  >
    <HoverTooltip
      content={tooltipContent}
      position={tooltipPosition}
      {...hoverTooltipProps}
    >
      <div
        {...inputWrapperProps}
        className={classNames('input__row', inputWrapperProps.className)}
      >
        {inputs.map((input, i) => (
          <Input
            id={`${id}-${i}`}
            key={`${name}-${i}`}
            disabled={isDisabled}
            required={isRequired}
            {...input}
          />
        ))}
      </div>
    </HoverTooltip>
    <ValidationMessage validationState={validationState} {...validationProps}>
      {validationMessage}
    </ValidationMessage>
  </InputWrapper>
);

InlineTextInput.defaultProps = {
  isRequired: false,
  isDisabled: false,
  inputWrapperProps: {}
};

InlineTextInput.propTypes = {
  /* Required */
  inputs: PropTypes.array.isRequired,
  /* Regular */
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  tooltipContent: PropTypes.string,
  tooltipPosition: PropTypes.string,
  type: PropTypes.oneOf([
    'text',
    'email',
    'number',
    'password',
    'tel',
    'date',
    'time',
    'checkbox',
    'radio',
    'textarea'
  ]),
  validationMessage: PropTypes.string,
  validationState: PropTypes.oneOf(['success', 'warning', 'error']),
  /* component props */
  hoverTooltipProps: PropTypes.object,
  inputLabelProps: PropTypes.object,
  inputWrapperProps: PropTypes.object,
  validationProps: PropTypes.object,
  wrapperProps: PropTypes.object
};

export default InlineTextInput;
